document.addEventListener('DOMContentLoaded', function () {
  const banners = document.querySelectorAll('.module_banner_link');
  if (!banners.length) return;

  banners.forEach(function (block) {
    block.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      const link = block.getAttribute('data-link');
      if (link) {
        window.location.href = link;
      }
    });

    block.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        const link = block.getAttribute('data-link');
        if (link) {
          window.location.href = link;
        }
      }
    });
  });
});